import {
    request,
    requestPublic
} from './request.js'

// 黑名单列表
// 获取黑名单列表
export function getList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/BlacklistSetting/GetList',
        method: 'get',
        params: {
            Page: obj.page,
            PageSize: obj.pageSize,
            IpAddress: obj.ipAddress,
            Reason: obj.reason,
            IsActive: obj.isActive,
            CreateTimeStart:obj.createTimeStart,
            CreateTimeEnd:obj.createTimeEnd,
        }
    })
}

// 添加黑名单
export function addBlackList(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/BlacklistSetting/Add',
        method: 'post',
        data: data
    })
}

// 编辑黑名单
export function editBlackList(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/BlacklistSetting/Edit',
        method: 'post',
        data: data
    })
}

// 获取黑名单详情
export function getBlackListDetail(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/BlacklistSetting/Get',
        method: 'get',
        params: {
            id: id
        }
    })
}

// 删除黑名单
export function deleteBlackList(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/BlacklistSetting/Delete?id='+ id,
        method: 'post',
        data: {}
    })
}